import ElectricBoltIcon from '@mui/icons-material/ElectricBolt'
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment'
import WaterDropIcon from '@mui/icons-material/WaterDrop'
import { Avatar } from '@mui/material'
import { color } from 'config/color'
import type React from 'react'

interface UtilityIconType {
  type: string
  bgColor?: string
  iconColor?: string
  fontSize?: number
}

const utilityDetails: Record<
  string,
  { icon: React.ElementType, bgColor: string, iconColor: string }
> = {
  electric: {
    icon: ElectricBoltIcon,
    bgColor: color.electricity[50],
    iconColor: color.electricity[400]
  },
  water: {
    icon: WaterDropIcon,
    bgColor: color.water[50],
    iconColor: color.water[400]
  },
  gas: {
    icon: LocalFireDepartmentIcon,
    bgColor: color.gas[50],
    iconColor: color.gas[400]
  }
}

export const UtilityIcon = ({
  type,
  bgColor,
  iconColor,
  fontSize
}: UtilityIconType): JSX.Element | null => {
  if (!utilityDetails[type]) return null

  const details = utilityDetails[type]
  const {
    icon: Icon,
    bgColor: defaultBgColor,
    iconColor: defaultIconColor
  } = details

  return (
    <Avatar sx={{ bgcolor: bgColor ?? defaultBgColor }}>
      <Icon sx={{ color: iconColor ?? defaultIconColor, fontSize }} />
    </Avatar>
  )
}
